<template>
  <div>
    <h4>
      User Roles Manager - {{ first_name }} {{ last_name }} ({{ user_name }})
    </h4>
    <p style="font-size: 1.1rem; color:black;">Edit User Roles</p>
    <br />
    <p>Use this screen to assign one or more roles to a user.</p>

    <div>
      <button
        type="button"
        class="tab mr-1"
        :style="
          role_unit ? 'font-weight: bold; color: black;' : ''
        "
        @click="switchTab('unit')"
      >
        Roles By Unit
      </button>
      <button
        type="button"
        class="tab"
        :style="
          role_history ? 'font-weight: bold; color: black;' : ''
        "
        @click="switchTab('history')"
      >
        Roles History
      </button>

      <RolesByUnit v-if="role_unit" />
      <RoleHistory v-if="role_history" />
    </div>
  </div>
</template>

<script>
import RolesByUnit from "./RolesByUnit.vue";
import RoleHistory from "./RoleHistory.vue";
export default {
  name: "AssignUserRoles",
  components: {
    RolesByUnit,
    RoleHistory,
  },
  data() {
    return {
      first_name: this.$route.params.first_name,
      last_name: this.$route.params.last_name,
      user_name: decodeURI(this.$route.query.user_name),
      role_history: false,
      role_unit: true,
    };
  },
  methods: {
    switchTab(tab) {
      if (tab === "history") {
        this.role_unit = false;
        this.role_history = true;
      } else {
        this.role_unit = true;
        this.role_history = false;
      }
    },
  },
};
</script>

<style scoped>
.tab {
  border-radius: 5px;
  padding: 5px 15px;
  border: 0px;
}
</style>
